export default __webpack_public_path__ + "static/media/frame-procuracao.e32feb23.png";